import UnitedCountry from './views/united_country.c';
export default UnitedCountry;
